<template>
  <StandardSearchPageView
    ref="tableWrap"
    rowKey="id"
    :columns="columns"
    :queryParams="queryParams"
    :request-promise="loadList"
    :enableSearch="false"
  >
    <template v-slot:auditStatus="{ record }">
      {{ record.platformStatusDesc || '-' }}
    </template>

    <template v-slot:templateType="{ record }">
      {{ record.templateTypeDesc || '-' }}
    </template>

    <template v-slot:enableStatus="{ record }">
      {{ isEnabled(record) ? '启用' : '禁用' }}
    </template>

    <template v-slot:action="{ record }">
      <a @click="toggleStatus(record)">
        {{ isEnabled(record) ? '禁用' : '启用' }}
      </a>
    </template>
  </StandardSearchPageView>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'TemplateTab',
  components: {
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {},
      columns: [
        { title: 'ID', dataIndex: 'id', width: 100 },
        { title: '关联签名名称', dataIndex: 'relatedSignName', width: 140 },
        {
          title: '状态',
          dataIndex: 'platformStatus',
          scopedSlots: { customRender: 'auditStatus' },
          width: 110
        },
        { title: '模板内容', dataIndex: 'templateContent', width: 320 },
        {
          title: '模板类型',
          dataIndex: 'templateType',
          scopedSlots: { customRender: 'templateType' },
          width: 140
        },
        { title: '模板名称', dataIndex: 'templateName', width: 140 },
        { title: '修改时间', dataIndex: 'updatedTime', width: 180 },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'enableStatus' },
          width: 90
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          // className: 'sticky-action-column',
          fixed: 'right',
          width: 100
        }
      ]
    }
  },
  methods: {
    loadList(requestParams) {
      const { limitDto } = requestParams
      return this.getHttpServices().getNewServeService().post('/smsTemplate/pageByMerchant', {
        limitDto
      })
    },
    isEnabled(record) {
      return Number(record.status) === 1
    },
    toggleStatus(record) {
      const status = this.isEnabled(record) ? 0 : 1
      this.getHttpServices().getNewServeService()
        .post('/smsTemplate/editStatus', {
          templateId: record.id,
          status
        })
        .then(() => {
          this.$message.success(status === 1 ? '启用成功' : '禁用成功')
          this.$refs.tableWrap.refresh(false)
        })
        .catch(err => this.showNetWorkErrorMessage(err))
    }
  }
}
</script>
